/**
* Copyright Aquera Inc 2026
*
* This source code is licensed under the BSD-3-Clause license found in the
* LICENSE file in the root directory of this source tree.
*/

import {css} from 'lit';

export const styles = css`
	:host {
		display: block;
		min-width: 0;
		font-family: var(--nile-font-family-sans-serif, var(--ng-font-family-body));
	}
	.item-body {
		display: flex;
		align-items: flex-start;
		min-width: 0;
		padding-top: var(--nile-spacing-xxsmall, var(--ng-spacing-xxs));
	}
	.body-content {
		box-sizing: border-box;
		min-width: 0;
		flex: 1 1 0%;
		max-width: 100%;
		color: var(--nile-colors-dark-500, var(--ng-componentcolors-alpha-black-50));
		font-size: var(--nile-type-scale-3, var(--ng-font-size-text-sm));
		font-weight: var(--nile-font-weight-regular, var(--ng-font-weight-regular));
		line-height: var(--nile-line-height-xsmall, var(--ng-line-height-text-xs));
	}
	.body-content nile-lite-tooltip {
		display: block;
		min-width: 0;
		max-width: 100%;
	}
	.body-text {
		display: -webkit-box;
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis;
		word-break: break-word;
		overflow-wrap: anywhere;
		-webkit-line-clamp: var(--line-clamp);
		line-clamp: var(--line-clamp);
	}
	/* Slotted block/paragraph nodes need the same clamp (slot composition) */
	.body-text ::slotted(*) {
		display: -webkit-box;
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis;
		word-break: break-word;
		overflow-wrap: anywhere;
		-webkit-line-clamp: var(--line-clamp);
		line-clamp: var(--line-clamp);
		margin-block: 0;
	}
	:host([disabled]) .body-content {
		color: var(--nile-colors-neutral-300, var(--ng-colors-text-disabled));
	}
`;

export default [styles];
